<template>
  <van-popup v-model:show="show" position="bottom" :closeable="true" class="center vh30 pad25 size16 b500" @close="handleClose">
    <div>{{title}}</div>
    <div class="Cred size24 pad20">
      <span class="size12">￥</span>{{ props.amount }}
    </div>
    <van-radio-group class="payBox" v-model="typeid">
      <van-radio name="2" label-position="left"><img src="@/assets/img/pay-wx.png" alt="" />
        <span class="inlnie" style="">微信支付</span>
      </van-radio>
      <van-radio name="1" label-position="left"><img src="@/assets/img/pay-aliay.png" alt="" /><span class="inlnie">支付宝支付</span></van-radio>
      <van-radio v-if="is_wusen &&  wusen_pay_status && wusen_status" name="3" label-position="left"><img class="radius50" src="@/assets/img/wusen.png" alt="" /><span class="inlnie">雾森支付</span>
      <span class="size12 C999 ml15">结余：{{ wusen_amount }}</span></van-radio>
      <div v-else-if="is_wusen && wusen_status && !wusen_pay_status" class="flex between">
        <p class="img"><img src="@/assets/img/wusen.png" alt=""  /><span class="inlnie">雾森支付</span><span class="size12 C999 ml15">结余：{{ wusen_amount }}</span></p>
        <p class="size13 Cred">余额不足</p> 
      </div>
    </van-radio-group>
    <van-button block round type="primary" class="mt90" @click="next">提交</van-button>
  </van-popup>
</template>
<script setup>
import { ref, defineProps, defineEmits, watchEffect,onMounted,watch } from "vue";
import ajax from "@/utils/request.js";

const props = defineProps({
  title: {
    type: String, default: '注资'//支付类型
  },
  showPopup: {//显示状态
    type: Boolean,
    default: false
  },
  nextFn: {
    type: Function,
    default: () => { }
  },
  amount: {//支付金额
    type: Number,
    default: null
  },
  // 是否使用雾森  但钱设计尽在商城板块使用雾森支付
  is_wusen:{
    type: Boolean,
    default: false
  }
})
// 雾森支付显示状态
const wusen_pay_status = ref(true)
const typeid = ref("1")
const show = ref(false)
const wusen_amount = ref(0)
// 雾森使用状态
const wusen_status = ref(1)
const emits = defineEmits(["update:showPopup"])
const handleClose = () => {
  emits("update:showPopup", false)
}

//提交执行函数
const next = () => {
  // 传递支付金额与支付方式
  props.nextFn(props.amount, typeid.value)
}
const handle = async () => {
  if (props.showPopup) {
    try {
      const res = await ajax.post("users/balance");
      wusen_amount.value = res.data.account_balance;
      wusen_status.value = res.data.wusen_status;

      // 使用 parseFloat 确保比较的是数字
      if (parseFloat(res.data.account_balance) > parseFloat(props.amount)) {
        wusen_pay_status.value = true;
      } else {
        wusen_pay_status.value = false;
      }
    } catch (error) {
      console.error("获取用户余额信息失败", error);
    }
  }
};
watch(
 handle()
);
watchEffect(() => {
  show.value = props.showPopup
  handle()
})
onMounted(()=>{
handle()
})
</script>

<style lang="scss" scoped>
</style>